import { render, staticRenderFns } from "./focuswords-chapter.vue?vue&type=template&id=4ce4becf"
import script from "./focuswords-chapter.ts?vue&type=script&lang=ts&external"
export * from "./focuswords-chapter.ts?vue&type=script&lang=ts&external"
import style0 from "./focuswords-chapter.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports